import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

// Reaproveita o layout apresentacional do DECOMP/Intersemanal/Semanal (texto +
// galeria de mapas) — mesmo contrato de dados (MensalChuva é estruturalmente
// igual a DecompChuva/SemanalChuva), sem necessidade de duplicar o componente.
import ChuvaLayout from 'components/Relatorios/Decomp/ChuvaLayout';
import { selectUserIsAdmin } from 'redux/reducers/authReducer';
import useMensalSecaoParams from 'hooks/Relatorios/Mensal/useMensalSecaoParams';
import { useGetMensalChuvaPrevistaQuery } from 'services/api/products/relatorios';

export default function ChuvaPrevista() {
  const userIsAdmin = useSelector(selectUserIsAdmin);
  const params = useMensalSecaoParams();

  const { data, isLoading } = useGetMensalChuvaPrevistaQuery(params);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <ChuvaLayout
      data={data}
      canEdit={userIsAdmin}
      variant="intersemanal"
      galeriaTitulo="CHUVA PREVISTA"
    />
  );
}
